<template>
  <custom-dialog
    :widthDialog="'800px'"
    :classDialog="'create-dialog custome-dialog'"
    :offsetTop="'0px !important'"
    :openDialog="isOpen"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('dialogClosed')"
  >
    <template #body>
      <h3 class="dialogTitle margin-left-0">Tạo mới yêu cầu điều xe</h3>
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-position="left"
        label-width="150px"
      >
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="Loại yêu cầu" prop="requestType">
              <el-select
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                v-model="form.requestType"
                placeholder="Loại yêu cầu"
                size="medium"
                filterable
                clearable
              >
                <el-option
                  v-for="item in requestTypes"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :gutter="24" class="">
            <el-form-item prop="sendSMS" label="Gửi SMS">
              <el-checkbox v-model="form.sendSMS"
                >Gửi nội dung tiêu đề đến điện thoại người dùng</el-checkbox
              >
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :gutter="24" class="">
            <el-form-item prop="sendEmail" label="Gửi Email">
              <el-checkbox v-model="form.sendEmail"
                >Gửi nội dung tiêu đề đến Email người dùng</el-checkbox
              >
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="24" class="margin-bottom-15">
            <el-form-item label="Tiêu đề" prop="title">
              <el-input
                type="textarea"
                v-model="form.title"
                placeholder="Tiêu đề"
                class="input-border__bottom input-border__radius__0 style-fullWidth input-count__bottom"
                size="medium"
                maxlength="500"
                show-word-limit
                :autosize="{ minRows: 2, maxRows: 5 }"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="24" class="margin-bottom-15">
            <el-form-item label="Nội dung yêu cầu" prop="title">
              <el-input
                type="textarea"
                v-model="form.content"
                placeholder="Nội dung yêu cầu"
                class="input-border__bottom input-border__radius__0 style-fullWidth input-count__bottom"
                size="medium"
                maxlength="2000"
                show-word-limit
                :autosize="{ minRows: 3, maxRows: 5 }"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="Số người đi" prop="numberOfPeople">
              <el-input-number
                size="medium"
                class="style-fullWidth input-border__bottom input-border__radius__0"
                v-model="form.numberOfPeople"
                placeholder="Số người đi"
                :controls="false"
                :min="0"
                :step="1"
                :precision="0"
                :max="100"
              >
              </el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Số điện thoại liên hệ" prop="contactNumber">
              <el-input
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                v-model="form.contactNumber"
                size="medium"
                placeholder="Số điện thoại liên hệ"
                @change="contactNumberChanged"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="24" class="margin-bottom-15">
            <el-form-item label="Địa điểm đi" prop="fromPlace">
              <el-input
                v-model="form.fromPlace"
                placeholder="Địa điểm đi"
                type="textarea"
                class="input-border__bottom input-border__radius__0 style-fullWidth input-count__bottom"
                size="medium"
                maxlength="1000"
                show-word-limit
                :autosize="{ minRows: 3, maxRows: 5 }"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="24" class="margin-bottom-15">
            <el-form-item label="Địa điểm đến" prop="toPlace">
              <el-input
                placeholder="Địa điểm đến"
                v-model="form.toPlace"
                type="textarea"
                class="input-border__bottom input-border__radius__0 style-fullWidth input-count__bottom"
                size="medium"
                maxlength="1000"
                show-word-limit
                :autosize="{ minRows: 3, maxRows: 5 }"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="24">
            <hc-dieuxe-cars-and-drivers
              ref="hcDieuXeCarsAndDrivers"
              v-if="!!flowId"
              :deptId="hcFlow.deptId"
              :required="false"
              class="margin-top-5"
            ></hc-dieuxe-cars-and-drivers>
          </el-col>

          <el-col :span="12">
            <el-form-item label="Thời gian đi" prop="startTime">
              <el-date-picker
                v-model="form.startTime"
                size="medium"
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                type="datetime"
                placeholder="dd/MM/yyyy HH:mm"
                format="dd/MM/yyyy HH:mm"
                :prefix-icon="' '"
                @change="startTimeChanged"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Thời gian về" prop="endTime">
              <el-date-picker
                v-model="form.endTime"
                size="medium"
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                type="datetime"
                placeholder="dd/MM/yyyy HH:mm"
                format="dd/MM/yyyy HH:mm"
                :prefix-icon="' '"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </template>

    <template #footer>
      <div class="flex-row form-button__action flex__left">
        <el-button
          :disabled="loading"
          size="medium"
          type="success"
          class="addDocs color__white bg__blue btn-none__border"
          @click="submit"
        >
          <i class="far fa-check-circle font-size__small"></i>
          &nbsp;Gửi yêu cầu
        </el-button>
        <el-button
          type="info"
          size="medium"
          class="btn__cancel btn-none__border"
          @click="$emit('closeDialog')"
          >Bỏ qua
        </el-button>
      </div>
    </template>
  </custom-dialog>
</template>
<script>
import hanhchinhService from "../../../services/hanhchinhService";
import handleRequestErrorMixin from "../../handleRequestErrorMixin";
import moment from "moment";
import CustomDialog from "../../common/custom-dialog";
import hanhChinhUtils from "../../../services/hanhChinhUtils";
import utils from "../../../services/utils";
import constants from "../../../constants";
import errorMessageFilter from "../../../filters/errorMessageFilter";
import hcFlowService from "../../../services/hcFlowService";
import HcDieuxeCarsAndDrivers from "./hc-dieuxe-cars-and-drivers";

export default {
  name: "hc-dieuxe-create-dialog",
  mixins: [handleRequestErrorMixin],
  props: ["isOpen", "id"],
  components: {
    HcDieuxeCarsAndDrivers,
    CustomDialog,
  },
  data() {
    return {
      loading: false,
      requestTypes: [],
      hcFlow: null,
      flowId: null,
      form: {
        requestType: null,
        title: null,
        content: null,
        numberOfPeople: 1,
        contactNumber: null,
        fromPlace: null,
        toPlace: null,
        startTime: null,
        endTime: null,
        sendSMS: false,
        sendEmail: false,
      },
      rules: {
        title: null,
        content: null,
        numberOfPeople: null,
        fromPlace: null,
        toPlace: null,
        startTime: null,
        endTime: null,
        contactNumber: null,
      },
    };
  },

  computed: {
    userDeptRole() {
      return this.$store.getters.userDeptRole;
    },
  },

  created() {
    if (!this.userDeptRole) return;
    this.initSelectOptions();
    this.initValidationRules();
    this.loadHcFlow();
    this.initForm();
  },

  methods: {
    contactNumberChanged() {
      this.form.contactNumber = utils.standardlizePhoneNumber(
        this.form.contactNumber
      );
    },

    loadHcFlow() {
      return hcFlowService
        .getHcFlowAlternativeForHcDieuXe()
        .then((response) => {
          this.hcFlow = response.data;
          this.flowId = this.hcFlow.id;
        });
    },

    startTimeChanged() {
      this.form.endTime = this.form.startTime
        ? new moment(this.form.startTime).add("1", "hour").toDate()
        : null;
    },

    initForm() {
      this.form.requestType = constants.HC_CASE_DIEUXE.REQUEST_TYPE.NOITHANH;
      this.form.startTime = new Date();
      this.form.endTime = new moment(this.form.startTime)
        .add("1", "hour")
        .toDate();
      this.form.contactNumber = this.userDeptRole.mobile;
    },

    initValidationRules() {
      let defaultRequiredConstrains = {
        required: true,
        message: "Trường dữ liệu bắt buộc",
        trigger: "blur",
      };
      let checkPhoneFormat = utils.buildPhoneValidationRule();

      this.rules.requestType = [defaultRequiredConstrains];
      this.rules.title = [defaultRequiredConstrains];
      this.rules.content = [defaultRequiredConstrains];
      this.rules.numberOfPeople = [defaultRequiredConstrains];
      this.rules.contactNumber = [
        defaultRequiredConstrains,
        { validator: checkPhoneFormat, trigger: "blur" },
      ];
      this.rules.fromPlace = [defaultRequiredConstrains];
      this.rules.toPlace = [defaultRequiredConstrains];
      this.rules.startTime = [defaultRequiredConstrains];
      this.rules.endTime = [defaultRequiredConstrains];
    },

    initSelectOptions() {
      this.requestTypes = hanhChinhUtils.buildDieuXeRequestTypeOptions();
    },

    convertToSubmitForm() {
      let listCarIdAndDriver = this.$refs.hcDieuXeCarsAndDrivers.collectCarsAndDrivers();
      return {
        flowId: this.flowId,
        requestType: this.form.requestType,
        title: this.form.title,
        content: this.form.content,
        numberOfPeople: this.form.numberOfPeople,
        contactNumber: this.form.contactNumber,
        fromPlace: this.form.fromPlace,
        toPlace: this.form.toPlace,
        startTime: this.form.startTime.getTime(),
        endTime: this.form.endTime.getTime(),
        listCarIdAndDriver: listCarIdAndDriver,
        sendSMS: this.form.sendSMS,
        sendEmail: this.form.sendEmail,
      };
    },

    validateForm() {
      return utils.validateFormCommon(this.$refs.form, this.$message);
    },

    validateCarsAndDrivers() {
      return this.$refs.hcDieuXeCarsAndDrivers.validateForm();
    },

    validateTime() {
      return new Promise((resolve) => {
        let isOk = this.form.startTime.getTime() < this.form.endTime.getTime();
        if (!isOk) {
          this.$message.error(
            errorMessageFilter({
              errorCode: "hcDieuXe.invalidTimeRange",
            })
          );
        } else {
          resolve();
        }
      });
    },

    submit() {
      this.validateForm()
        .then(() => this.validateTime())
        .then(() => this.validateCarsAndDrivers())
        .then(() => {
          this.loading = true;
          let submitForm = this.convertToSubmitForm();
          return hanhchinhService
            .registerCarRequest(submitForm)
            .then((response) => response.data);
        })
        .then((hcCaseCommands) => {
          this.loading = false;
          this.$message.success(
            errorMessageFilter({
              errorCode: "hcDieuXe.insertSuccess",
            })
          );
          this.$emit("insertSuccess", { result: hcCaseCommands });
        })
        .catch((error) => {
          this.loading = false;
          this.commonHandleRequestError(error);
          throw error;
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/adminstration/dieuxe/hc-dieuxe-create-dialog.vue